import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const DeleteCouponPermission = props => {

  const buttonConfig = {
    primary: {
      label: 'SİL',
      onClick: props.onPrimaryButtonClick
    },
    secondary: {
      label: 'VAZGEÇ',
      onClick: props.onSecondaryButtonClick
    }
  };

  return (
    <Message type="none" buttonConfig={ buttonConfig } >
      { EnvironmentManager.getMessageText({ key: 'betslip_delete_text_message' }) }
    </Message>
  );
};

DeleteCouponPermission.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  onSecondaryButtonClick: PropTypes.func.isRequired
};

export default DeleteCouponPermission;